// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ccYKZ2pQyJEiXPkIjcos{flex-direction:column;min-height:100%;display:flex}.WrcljF6JQvEEnHxWesLC{flex-direction:column;flex-grow:1;gap:32px;padding:16px 24px 24px;display:flex}.Trc_x11qzTA16Msrco5L{gap:8px;margin-top:12px;margin-bottom:24px;display:flex}.bVfF1rljatM6UxJr7mFU{margin-top:-8px;margin-bottom:16px}.OCsCj9hwgGl_CQY70RUo{flex-grow:1;align-content:flex-end;padding-right:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollbarView": `ccYKZ2pQyJEiXPkIjcos`,
	"wrap": `WrcljF6JQvEEnHxWesLC`,
	"info": `Trc_x11qzTA16Msrco5L`,
	"alert": `bVfF1rljatM6UxJr7mFU`,
	"footer": `OCsCj9hwgGl_CQY70RUo`
};
export default ___CSS_LOADER_EXPORT___;
